import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/global.css";
import "./i18n";
import { App } from "./App";
import { initTelemetry, SentryErrorBoundary } from "./analytics";
import { installConsoleCapture } from "./utils/bugCapture";

// Initialise Sentry + Mixpanel before the first render.
// Both are no-ops when VITE_SENTRY_DSN / VITE_MIXPANEL_TOKEN are unset.
initTelemetry();
// Start capturing console errors for the in-app bug reporter (best-effort; idempotent).
installConsoleCapture();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

createRoot(rootEl).render(
  <StrictMode>
    <SentryErrorBoundary
      fallback={({ error }: { error: Error }) => (
        <div style={{ padding: "2rem", fontFamily: "sans-serif" }}>
          <h2>Something went wrong</h2>
          <pre style={{ fontSize: "0.85rem", color: "#c00" }}>{error.message}</pre>
          <button onClick={() => window.location.reload()}>Reload</button>
        </div>
      )}
    >
      <App />
    </SentryErrorBoundary>
  </StrictMode>,
);
